import Timestampable from '@/models/Timestampable'
import {
  id,
  GardenInterface,
  GardenDocInterface,
  GardenMapInterface,
} from '@/types/models'
import { auth, serverTimestamp, firestoreTimestampToDate } from '@/firebase'
import Image from '@/models/Image'

import store from '@/store'
import Plant from './Plant'
import LogItem from './LogItem'
import {
  DocumentData,
  QueryDocumentSnapshot,
  SnapshotOptions,
} from 'firebase/firestore'

export default class Garden extends Timestampable {
  isNew = false

  id: id
  name: string
  map: GardenMapInterface
  note: string | null | undefined

  collections() {
    return {
      'plants/bind': this.id,
      'log/bind': this.id,
      'images/bind': this.id,
    }
  }

  constructor(data: GardenInterface) {
    super(data)

    this.id = data.id
    this.name = data.name
    this.map = data.map
    this.note = data.note

    this.isNew = data.isNew || false
  }

  get plants(): Plant[] {
    return store.getters['gardens/plants/inGarden'](this.id)
  }

  get images(): Image[] {
    return store.getters['gardens/images/inGarden'](this.id)
  }

  get log(): LogItem[] {
    return store.getters['gardens/log/inGarden'](this.id)
  }

  static fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
    // plantId: id,
  ): Garden {
    const data = snapshot.data(options)

    const result: GardenInterface = {
      id: snapshot.id,
      name: data.name,
      map: data.map,
      note: data.note,

      createdBy: data.createdBy,
      createdAt: firestoreTimestampToDate(data.createdAt),
      updatedBy: data.updatedBy,
      updatedAt: firestoreTimestampToDate(data.updatedAt),

      isNew: false,
    }

    return new Garden(result)
  }

  static firestoreConverter = () => ({
    toFirestore(garden: Garden): DocumentData {
      const g: GardenDocInterface = {
        name: garden.name,
        note: garden.note || null,
      }

      if (garden.isNew) {
        g.createdBy = auth.currentUser()?.uid
        g.createdAt = serverTimestamp()
      } else {
        g.updatedBy = auth.currentUser()?.uid
        g.updatedAt = serverTimestamp()
      }

      // console.log(g)

      return g
    },
    fromFirestore(
      snapshot: QueryDocumentSnapshot,
      options: SnapshotOptions
    ): Garden {
      return Garden.fromFirestore(snapshot, options)
    },
  })
}
